import React, { useMemo, FunctionComponent } from "react";

import { useTranslate } from "../translation/frontend";

// TODO: `type` should be of type QuestionType
export function useErrorLabel(type?: string) {
  const translate = useTranslate();
  return useMemo(() => {
    switch (type) {
      case "TEXT":
        return translate("textQuestionInvalid");
      case "EMAIL":
        return translate("emailQuestionInvalid");
      case "PHONE":
        return translate("phoneQuestionInvalid");
      case "IMAGE":
        return translate("imageQuestionInvalid");
      case "radio":
        return translate("radioQuestionInvalid");
      case "checkbox":
        return translate("checkboxQuestionInvalid");
      default:
        return translate("defaultQuestionInvalid");
    }
  }, [translate, type]);
}

const ErrorMessage: FunctionComponent<{ id: string; type?: string; message?: string }> = ({ id, type, message }) => {
  const defaultErrorLabel = useErrorLabel(type);
  const errorLabel = message ?? defaultErrorLabel;
  const translate = useTranslate();

  return (
    <span id={`${id}-error`} className="error-message">
      <svg
        className="error-message__icon"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <g transform="translate(-147 -271)">
          <circle cx="12" cy="12" r="12" transform="translate(147 271)" fill="#c83723" />
          <rect width="2" height="8" rx="1" transform="translate(158 277)" fill="#fff" />
          <rect width="2" height="3" rx="1" transform="translate(158 286)" fill="#fff" />
        </g>
      </svg>
      <span className="is-sr-only">{translate("errorLabelTitle")}</span> {errorLabel}
    </span>
  );
};

export default ErrorMessage;
